<template>
  <div class="credit-page">
    <div class="content-panel">
      <img
        class="aspire-logo"
        src="@/components/AppMenu/img/aspire-logo.svg"
        alt="Aspire-Logo-Large"
      />
      <div class="aspire-desc">Credit feature is not available for now</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CrediView",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>